
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".6","clip-path":"url(#clip0_995_7649)","fill":"#fff"}},[_c('path',{attrs:{"d":"M13.354 9.098a.255.255 0 00-.116-.029.305.305 0 00-.22.095l-.616.606a.282.282 0 00-.087.208v2.405c0 .417-.15.773-.452 1.07a1.494 1.494 0 01-1.087.445H2.77c-.423 0-.786-.148-1.087-.445a1.447 1.447 0 01-.452-1.07V4.505c0-.417.15-.774.452-1.07A1.493 1.493 0 012.77 2.99h8.005c.14 0 .285.019.433.056a.31.31 0 00.086.02.306.306 0 00.221-.095l.472-.464a.292.292 0 00.087-.275.288.288 0 00-.174-.218 2.685 2.685 0 00-1.125-.237H2.77c-.763 0-1.416.267-1.958.801A2.606 2.606 0 000 4.505v7.879c0 .75.27 1.393.813 1.927a2.69 2.69 0 001.958.8h8.004a2.69 2.69 0 001.958-.8 2.607 2.607 0 00.813-1.927V9.372c0-.132-.064-.224-.192-.275z"}}),_c('path',{attrs:{"d":"M7.36 12.614a.128.128 0 01-.22.002c-.833-1.397-3.137-4.482-3.137-4.482l-.458-.593a.165.165 0 01-.009-.013c-.202-.332.276-.875.673-.631l.628.426 2.287 1.572a.128.128 0 00.173-.026c1.467-1.851 2.83-3.13 3.726-3.885 1.006-.847 1.62-1.224 1.644-1.242 1.145-.822 2.416-1.324 3.164-1.574.135-.046.232.129.12.216 0 0-.962.706-2.01 1.561C10.8 6.7 7.394 12.555 7.36 12.614z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_995_7649"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    